import axios, { AxiosInstance } from "axios";
// import { response } from "express";
import {
  distanceListResponse,
  distanceListDayWiseResponse,
  distanceListYearWiseResponse,
  cycleIdModalResponse,
} from "../../@Types/DRO/ApiResponses";

export class DistanceReport {
  public static api = new DistanceReport();
  private instance: AxiosInstance;
 
  constructor() {
    this.instance = axios.create({
      baseURL: "https://data.bcykal.com/distance/",
      timeout: 15000,
    });

    // 🔥 GLOBAL RESPONSE INTERCEPTOR (MOST IMPORTANT)
    this.instance.interceptors.response.use(
      (response) => {
        // ✅ success → direct pass
        return response;
      },
      (error) => {
        // ✅ ERROR SIRF CONSOLE ME
        console.error("Axios Distance API Error:", {
          url: error?.config?.url,
          method: error?.config?.method,
          status: error?.response?.status,
          message: error?.message,
        });

        // 🔥 CRITICAL FIX:
        // ❌ reject / throw NAHI
        // ✅ resolve with SAFE response
        return Promise.resolve({
            data: []   // 👈 array

        });
      }
    );
  }
  formatDate = (date: Date | null): string | null => {
    if (!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adjust month to be 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  };
 distanceReportList(
  page: number,
  pageSize: number,
  startDate: Date | null,
  endDate: Date | null
): Promise<distanceListResponse> {
  const formattedStartDate = startDate ? this.formatDate(startDate) : null;
  const formattedEndDate = endDate ? this.formatDate(endDate) : null;

  let apiUrl = "distanceList";
  if (endDate) {
    apiUrl += `?Date=${formattedStartDate}&Date2=${formattedEndDate}`;
  }

  return this.instance
    .get<distanceListResponse>(apiUrl, {
      headers: { key: "secret-key" },
      params: { page, size: pageSize },
    })
    .then((res) => res.data); // ✅ always safe
}

  distanceReportDayWiseList(
    page: number,
    pageSize: number,
    date: string
  ): Promise<distanceListDayWiseResponse> {
    let apiUrl = "distanceList/day";
    if (date) {
      apiUrl += `/${date}`;
    }
    return this.instance
      .get<distanceListDayWiseResponse>(apiUrl, {
        headers: {
          key: "secret-key",
        },
        params: {
          page: page,
          size: pageSize,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  cycleIdModalData(
    page: number,
    pageSize: number,
    cycleId: number | undefined,
    startDate: Date | null,
    endDate: Date | null
  ): Promise<cycleIdModalResponse> {
    const formattedStartDate = startDate ? this.formatDate(startDate) : null;
    const formattedEndDate = endDate ? this.formatDate(endDate) : null;
    let apiUrl = "distanceList/listCycleId";
    if (endDate) {
      apiUrl += `/${cycleId}?Date=${formattedStartDate}&Date2=${formattedEndDate}`;
    }
    return this.instance
      .get<cycleIdModalResponse>(apiUrl, {
        headers: {
          key: "secret-key",
        },
        params: {
          page: page,
          size: pageSize,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  distanceReportYearWiseList(
    year: string,
    month: string | undefined
  ): Promise<distanceListYearWiseResponse> {
    let apiUrl = "distanceList/year";
    const selectedyear = year ? year : null;
    const selectedmonth = month ? month : null;
    return this.instance
      .get<distanceListYearWiseResponse>(apiUrl, {
        headers: {
          key: "secret-key",
        },
        params: {
          year: selectedyear,
          month: selectedmonth,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
}
